<template>
  <div class="flex flex-col gap-y-3">
    <strong>{{ state.model?.number }}</strong>
    <ul class="flex gap-x-5">
      <c_cell title="预付金额">
        <template #default>
          <c_money :key="state.model?.amount" :value="state.model?.amount" />
        </template>
      </c_cell>
      <c_cell title="付款方式" :value="state.model?.d_payment_type_name" />
    </ul>
    <c_cell title="收款信息">
      <template #default>
        <div class="flex gap-x-2">
          <text>{{ state.model?.supplier_bank_account?.opening_bank }}</text>
          <text class="text-gray-400">{{
            state.model?.supplier_bank_account?.name
          }}</text>
          <text class="text-gray-400">{{
            state.model?.supplier_bank_account?.account
          }}</text>
        </div>
      </template>
    </c_cell>
    <c_cell title="申请说明" :value="state.model?.intro" />
    <c_cell title="附件">
      <template #default>
        <c_UploadFile
          v-if="state.model?.attachment?.length > 0"
          :key="state.model?.attachment"
          :value="state.model?.attachment"
          :showAdd="false"
          :showText="true"
        />
        <text v-else>-</text>
      </template>
    </c_cell>
    <strong>审核进度</strong>
    <el-steps :active="state.model.step" align-center>
      <el-step
        v-for="item in state.flowApproveStepList"
        :key="item"
        :title="item.step_name"
        :description="state.model.create_time"
      >
        <template #description>
          <div class="flex flex-col items-center">
            <template v-if="item.status">
              <ul class="flex gap-x-1">
                <c_status
                  arrName="Common_Check_Status"
                  :value="item.status"
                  showBg
                />
                <text>{{ item.approve_admin_name }}</text>
                <text>{{ item.approve_department_name }}</text>
              </ul>
              <text>{{ item.approve_time }}</text>
            </template>
            <c_status
              v-else
              arrName="Common_Check_Status"
              :value="item.status"
              showBg
            />
          </div>
        </template>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { supplier_payment_apply_search } from "@/http/supplier";
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      if (props.id) {
        supplier_payment_apply_search(props.id).then((res) => {
          if (res.status == 200) {
            const { info, flowApproveStepList } = res.data?.data || {};
            state.model = info;
            state.flowApproveStepList = flowApproveStepList;
          }
        });
      }
    });
    return { state };
  },
};
</script>
<style scoped></style>
